// @flow
import JQueryView, { on } from '../common/JQueryView';

declare var $: any;

export default class IndexView extends JQueryView {
  show: string;

  constructor(show: string) {
    super('#index_view');
    if (show) {
      $(`#Modal-${show}`).modal('show');
    }
  }

  @on('click .toggle-button-financial-document')
  onClickToggleButtonFinancialDocument() {
    const modalId = document.getElementsByClassName('modal fade show')[0].id;
    const toggleIconId =
      '#toggle-icon-financial-document-' + modalId.replace('Modal-', '');
    $(toggleIconId).toggleClass('fa-caret-square-down fa-caret-square-up');
  }

  @on('click .toggle-button-annual-report')
  onClickToggleButtonAnnualReport() {
    const modalId = document.getElementsByClassName('modal fade show')[0].id;
    const toggleIconId =
      '#toggle-icon-annual-report-' + modalId.replace('Modal-', '');
    $(toggleIconId).toggleClass('fa-caret-square-down fa-caret-square-up');
  }

  @on('click .toggle-button-trade-list')
  onClickToggleButtonTradeList() {
    const modalId = document.getElementsByClassName('modal fade show')[0].id;
    const toggleIconId =
      '#toggle-icon-trade-list-' + modalId.replace('Modal-', '');
    $(toggleIconId).toggleClass('fa-caret-square-down fa-caret-square-up');
  }
}
